import Vue from 'vue'
import helpers from 'src/helpers/'

export default {
  tableProductList: state => {
    return state.productList
  },
  locationOptions: state => {
    if (typeof state.saveData.data !== 'undefined') {
      if (typeof state.saveData.data.location !== 'undefined') {
        let options = state.saveData.data.location.list.map(opt => ({
          label: opt.name,
          value: opt.id,
        }))
        return options
      }
    }
    return []
  },
  taxable: state => {
    // Check taxable if tax object exist
    let tax = true
    if (typeof state.saveData.data !== 'undefined') {
      if (typeof state.saveData.data.tax_zones !== 'undefined') {
        state.saveData.data.tax_zones.forEach(x => {
          if (parseFloat(x.tax_value) > 0) {
            tax = false
          }
        })
      }
    }
    return tax
  },
  taxZones: state => {
    if (typeof state.saveData.data !== 'undefined') {
      if (typeof state.saveData.data.tax_zones !== 'undefined') {
        return state.saveData.data.tax_zones
      }
    }
    return []
  },
  taxLabel: state => {
    if (typeof state.saveData.data !== 'undefined') {
      if (typeof state.saveData.data.tax_zones !== 'undefined') {
        if (state.saveData.data.tax_zones.length > 0) {
          if (typeof state.saveData.data.tax_zones[0].tax !== 'undefined') {
            return (
              state.saveData.data.tax_desc +
              ' ' +
              window.il8n.t('Common.inclusive.label') +
              ' (' +
              state.saveData.data.tax_zones[0].tax.code +
              ')'
            )
          }
        }
      }
    }
    return ''
  },
  currencyLabel: state => {
    if (typeof state.saveData.data !== 'undefined') {
      if (typeof state.saveData.data.currency !== 'undefined' && state.saveData.data.currency !== null) {
        if (typeof state.saveData.data.currency.code !== 'undefined' && state.saveData.data.currency.code !== null) {
          return state.saveData.data.currency.code
        }
      }
    }
    return ''
  },
  getKittingQualifiedBaseCVS: state => {
    return state.kittingQualifiedBaseCVS.data
  },
  tableKittingList: state => {
    return state.kittingList
  },
  tableProductGroupingList: state => {
    return state.productGroupingList
  },
  tablePwpFocList: state => {
    return state.pwpFocList
  },
  getProductData: state => {
    return state.saveData
  },
  getKittingData: state => {
    return state.saveData
  },
  getKittingStats: state => {
    return {
      hasSales: helpers.getValue(state.kittingStats, 'data.total_sale_with_kitting', 0) > 0,
    }
  },
}
